var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 27,
    viewBox: "0 0 155 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86423 16.3073V21.1487L3.27451 19.5601L0 16.2867V9.76373L0.00488977 9.7583V14.6225L3.25767 11.3757V14.6426L3.2593 14.7024L4.86423 16.3073Z",
    fill: "#0CDEEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.038 9.77382V11.4043L22.7749 14.6636V14.6582V11.4054L21.1281 9.7586V4.87427L26.038 9.77382Z",
    fill: "#0CDEEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5119 16.2389V22.7445L19.5022 22.7548V22.7956L16.2695 26.0277H14.6461L14.6396 26.0217L11.3917 22.77H14.6026L16.2494 21.1233V19.502L6.49049 9.74313V8.15233L6.4856 8.15776V3.27614L9.76337 0L11.39 0.00380315H11.3993L14.651 3.2593H14.6493L14.6428 3.25278H11.39L9.74327 4.89955V6.50067H9.75359L19.5022 16.2286L19.5119 16.2389Z",
    fill: "#0CDEEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5021 3.23112V8.11166L14.6493 3.2593H14.651L11.3993 0.00380315L16.2797 0.0152872L19.5021 3.23112Z",
    fill: "#0CDEEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6461 26.0277L9.76387 26.0277L6.49044 22.7548V17.9004L11.39 22.77L11.3917 22.77L14.6396 26.0217L14.6461 26.0277Z",
    fill: "#0CDEEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86416 4.89966V9.76389L3.2576 11.3699V11.3759L0.00482178 14.6227V9.75846L4.86416 4.89966Z",
    fill: "#9A00EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.038 11.4041V16.2797L21.1281 21.189V16.3047L26.038 11.4041Z",
    fill: "#9A00EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7337 7.24246H48.2644L46.2794 5.13366L37.1198 5.11939L35.4529 6.59572V12.1728L46.2509 14.9827V18.6874H35.7202L37.6376 20.8105H46.8656L48.5316 19.335V13.3565L37.7337 10.5466V7.24246Z",
    fill: "#0CDEEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9749 9.2674L52.8995 10.1737V5.97753L52.2465 5.11938H50.6188V20.8105H52.8995V12.7821L54.4898 11.4172H59.5992V20.8105H61.8533V10.4547L60.5659 9.2674H53.9749Z",
    fill: "#0CDEEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4351 9.26739V11.3905H72.7207V13.683H65.2414L63.954 14.8703V19.624L65.2414 20.8113H71.7291L72.865 20.021L73.0566 20.8113H75.0015V10.4208L73.6802 9.26829H64.4351V9.26739ZM72.7207 15.699V17.6446L71.2872 18.6606H66.2081V15.699H72.7207Z",
    fill: "#0CDEEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.107 9.2674V24.7444H78.7285L79.3878 23.9192V20.0736L80.431 20.8105H86.8065L88.1277 19.657V10.4199L86.8065 9.2674H77.107ZM85.8469 11.4172V18.6874H80.9282L79.3878 17.592V11.4172H85.8469Z",
    fill: "#0CDEEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5489 9.26739L90.2277 10.4199V18.2797L92.8737 20.8096H100.66V18.6865H93.8243L92.455 17.3154V16.1531H99.92L101.248 15.0612V10.419L99.9271 9.2665H91.548L91.5489 9.26739ZM92.5084 14.1647V11.3905H98.9676V14.1647H92.5084Z",
    fill: "#0CDEEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.214 9.2674L121.139 10.1737V5.97753L120.486 5.11938H118.857V20.8105H121.139V12.7821L122.728 11.4172H127.838V20.8105H130.092V10.4547L128.805 9.2674H122.214Z",
    fill: "#0CDEEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.474 9.26739H132.194V20.8105H134.474V9.26739Z",
    fill: "#0CDEEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.194 5.11938V8.60728H134.474V5.9365L133.78 5.11938H132.194Z",
    fill: "#0CDEEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M138.033 6.27281V9.2674H136.563V11.3905H138.033V20.8105H140.287V11.3905H144.964V9.2674H140.287V7.24246H144.964V5.11938H139.354L138.033 6.27281Z",
    fill: "#0CDEEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155 11.3905V9.2674H150.537V7.38965L149.878 6.5645H148.256V9.2674H146.786V11.3905H148.256V19.6579L149.577 20.8105H155V18.6874H150.537V11.3905H155Z",
    fill: "#0CDEEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2794 5.13366L48.5067 6.59572V12.1728L46.2794 11.5484V5.13366Z",
    fill: "#0CDEEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6376 13.8918L35.4103 13.3565V19.335L37.6376 20.8337V13.8918Z",
    fill: "#0CDEEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.705 7.26752H116.236L114.251 5.15872L105.091 5.14445L103.424 6.62079V12.1978L114.222 15.0078V18.7124H103.692L105.609 20.8355L114.837 20.8355L116.503 19.3601V13.3816L105.705 10.5717V7.26752Z",
    fill: "#0CDEEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.251 5.15872L116.478 6.62079V12.1978L114.251 11.5734V5.15872Z",
    fill: "#0CDEEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.609 14.1647L103.382 13.6295V19.3601L105.609 20.8587V14.1647Z",
    fill: "#0CDEEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2211 24.771L63.9412 23.6778V22.9312H75.0335V24.771H65.2211Z",
    fill: "#BEEB17"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.11fb17fe7979052dfd55ba969ff9e7a2.svg";
export { ForwardRef as ReactComponent };